// extracted by mini-css-extract-plugin
export default {"root":"Logo_root__53KOa","placeHolderShimmer":"Logo_placeHolderShimmer__3qn+s"};